import React from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import 'react-perfect-scrollbar/dist/css/styles.css'
import CustomNavbar from './PublicNavbar'
import Footer from './Footer'

export default function CookiesPolicy() {
    return (
        <>
            <CustomNavbar />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12" style={{ marginTop: '70px' }}>
                        <div className='layout '>
                            <h5>Cookies Policy</h5>
                        </div>
                        <div className="layout mt-3 p-3">
                            <PerfectScrollbar
                                style={{
                                    overflow: 'auto',
                                    height: '60vh',
                                    position: 'relative',
                                    insetInlineStart: 0,
                                }}
                                options={{ suppressScrollX: true }}
                            >
                                <h6>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Quo, blanditiis pariatur aliquid reprehenderit error, sapiente sequi saepe earum, esse molestias ipsum magnam repellat nobis soluta totam incidunt minus itaque consequatur.</h6>
                            </PerfectScrollbar>
                        </div>
                    </div>
                </div>
            </div>
            <div className='fixed-bottom'>
                <Footer />
            </div>
        </>
    )
}
